import React from 'react'
import MyTable from '../../../../UI/table/MyTable'
import { TableCell } from '@mui/material'
import MyTableNotFound from '../../../../UI/table/MyTableNotFound'
import SupplyBillDeliveryItem from './SupplyBillDeliveryItem'
import { useSelector } from 'react-redux'

const SupplyBillDeliveryTable = ({  }) => {
    
    const supplyBill = useSelector(state => state.supplyBill.supplyBill)

  return (
    <MyTable
        head={
            <>
                <TableCell align="center">№ (ID)</TableCell>
                <TableCell align="center">Тип</TableCell>
                <TableCell align="center">ТТН</TableCell>
                <TableCell align="center">Статус</TableCell>
                <TableCell align="center">Планова дата</TableCell>
                <TableCell align="center">Дії</TableCell>
            </>
        }
        body={
            // deliveries && deliveries.length > 0 ?
            //     deliveries.map((delivery, index) => 
            supplyBill.deliveries && supplyBill.deliveries.length > 0 ?
                supplyBill.deliveries.map((delivery, index) => 
                    <SupplyBillDeliveryItem
                        key={delivery.id}
                        index={index}
                        delivery={delivery} 
                        // checked={checked}
                        // setChecked={setChecked}
                    />
                )
            : 
                <MyTableNotFound
                    text='Доставок не знайдено' 
                    // columns={6}
                />
        }
        name='доставок'
        hidePagination={true}
    />
  )
}

export default SupplyBillDeliveryTable